import { MDBox } from "../MDBox";

interface IClientHeaderBanner {
    banner: string;
}
export const ClientHeaderBanner = (props: IClientHeaderBanner) => {
  return (
    <>
      <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: '80px' }}>
          <img src={"data:image/png;base64," + props.banner} style={{
              objectFit: "fill",
          }}></img>
      </MDBox>
    </>
  );
}